import React from "react";
import "./TextComponentOTF.scss";
import { useSelector } from "react-redux";
import renderHTML from "react-render-html";
import { IconMeetingVideoHoc, ImgFavicon } from "../../../../../../assets/images";
import { CALL_STATUS_CONNECTED } from "../../../../../../Helpers/Call/Constant";
import {
  blockOfflineAction,
  convertTextToURL,
  getFormattedText,
  getSiteDomain,
  isCallLink
} from "../../../../../../Helpers/Utility";
import Translate from "./Translate";
import SDK from "../../../../../../SDK";
import { store } from "../../../../../../Redux/store";
import { showModal } from "../../../../../../Redux/feature/popUpDataSlice";
import { addCallIntermediate } from "../../../../../../Redux/feature/callIntermediateScreenSlice";

const TextComponentOTF = (props = {}) => {
  const { messageObject = {}, isSender = false, pageType } = props;
  const { msgBody = {} } = messageObject;
  const messageLink = convertTextToURL(msgBody.message);
  const { data: conferenceData = {} } = useSelector((state) => state.showConfrenceData || {});
  const { data: callData = {} } = useSelector((state) => state.callIntermediateScreen || {});

  const isTranslated = () =>
    !isSender &&
    pageType === "conversation" &&
    msgBody?.translatedMessage &&
    Object.keys(msgBody.translatedMessage).length;

  const renderMessageBody = () => (msgBody ? renderHTML(getFormattedText(messageLink)) : null);

  const subscribeToCall = async () => {
    if (blockOfflineAction()) return "";
    const callLink = msgBody.message?.split(`${getSiteDomain()}/`)[1];
    if (callData && conferenceData.callStatusText === CALL_STATUS_CONNECTED) {
      const roomLink = await SDK.getCallLink();
      if (msgBody.message.includes(roomLink.data)) {
        props.handleShowCallScreen();
      } else {
        store.dispatch(
          showModal({
            open: true,
            modelType: "CallConfirm",
            newCallLink: callLink
          })
        );
      }
    } else {
      store.dispatch(addCallIntermediate({ show: true, link: callLink }));
    }
  };
  return (
    <React.Fragment>
      {isCallLink(msgBody.message) ? (
        <div className="message_meeting_link">
          <button type="button" className="meetingL_link_share" onClick={() => subscribeToCall()}>
            <div className="meeting_link_detail">
              <span className="meeting_ink">{msgBody.message}</span>
            </div>
            <div className="meeting_desc">
              <img src={ImgFavicon} alt="Mirrorfly Video Call" />
              <span className="call_details">Join video call</span>
              <span className="call_icon">
                <IconMeetingVideoHoc viewBox="0 0 25.787 16.332"/>
              </span>
            </div>
            {!!isTranslated() && <Translate tMessage={msgBody?.translatedMessage} />}
            <div className="company_detais">
            </div>
          </button>
        </div>
      ) : (
        <div className="message-text">
          <span>{renderMessageBody()}</span>
          {!!isTranslated() && <Translate tMessage={msgBody?.translatedMessage} />}
        </div>
      )}
    </React.Fragment>
  );
};

export default TextComponentOTF;
